import React from "react"
import { store } from "../../../stores/Store"

export default function QuestionnairePreloadedAnswers () {

    const { questionnaire } = store.QuestionnaireStore
    const [preloadedAnswers, setPreloadedAnswers] = React.useState(null)

    var height = "400px"

    React.useEffect(() => {
        try {
            var pa = JSON.parse(questionnaire.preloadedAnswers)
            setPreloadedAnswers(pa)
        } catch (e) {
            console.log(e)
        }
    }, [])

    if (!preloadedAnswers) {
        return <p>There are no preloaded answers for this Questionnaire.</p>
    }

    return (
        <div>
            <p>{Object.keys(preloadedAnswers).length} preloaded answers.</p>

            <div className="questionnaire-pages" style={{maxHeight: height}}>
                {Object.keys(preloadedAnswers).map((fieldName, p) => {

                    if (Array.isArray(preloadedAnswers[fieldName])) {
                        return <></>
                    }

                    if (typeof preloadedAnswers[fieldName] === "string") {
                        return <QuestionnaireField label={fieldName} value={preloadedAnswers[fieldName]} />
                    }
                })}
            </div>
        </div>
    )
}

function QuestionnaireField ({label, value}) {
    return (
        <div style={{display: "grid", gridTemplateColumns: "60% 40%", margin: "0px 0 0 10px"}}>
            <small>{label}</small>
            <small>{value}</small>
        </div>
    )
}